module.exports = __webpack_public_path__ + "static/liva-convert-detail-three-d7fb7b0ac72bf5e59f4faefaca38142a.png";